'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const components_marketing_Hero_constants = require('./constants.cjs.js');

const transformBackgroundColor = (backgroundColor) => {
  return components_marketing_Hero_constants.backgroundColorMap[backgroundColor] || backgroundColor;
};
const mapBackgroundColorToV5HeadingColorName = (color) => {
  const colorMap = {
    neutral100: "TextDefault",
    zapier: "BrandCream"
  };
  return colorMap[color] || "TextInverted";
};
const mapBackgroundColorToV5TextColorName = (color) => {
  const colorMap = {
    neutral100: "TextDefault",
    zapier: "BrandCream"
  };
  return colorMap[color] || "TextInverted";
};
const validateZapierBackgroundAccessibility = (backgroundColor, isSubscriptionForm, isCtaDisclaimerEnabled) => {
  const isZapierOrange = backgroundColor === "zapier";
  if (isZapierOrange && (isSubscriptionForm || isCtaDisclaimerEnabled)) {
    console.error(`Do not use the ${isSubscriptionForm ? "subscription form" : "cta disclaimer"} with the zapier background. The disclaimer text accessibility is poor on the zapier background.`);
  }
};
const getSupportedCTAColor = (ctaColor, backgroundColor) => {
  const supportedCTAColors = {
    // Note: Value present at 0th index is considered the default CTA color
    neutral100: ["primary", "brand"],
    zapier: ["primary-dark"],
    night: ["primary-dark", "brand"],
    moss: ["primary-dark", "brand"],
    neutral800: ["primary-dark", "brand"]
  };
  if (supportedCTAColors[backgroundColor].includes(ctaColor)) {
    return ctaColor;
  }
  return supportedCTAColors[backgroundColor][0];
};

exports.getSupportedCTAColor = getSupportedCTAColor;
exports.mapBackgroundColorToV5HeadingColorName = mapBackgroundColorToV5HeadingColorName;
exports.mapBackgroundColorToV5TextColorName = mapBackgroundColorToV5TextColorName;
exports.transformBackgroundColor = transformBackgroundColor;
exports.validateZapierBackgroundAccessibility = validateZapierBackgroundAccessibility;
//# sourceMappingURL=utils.cjs.js.map
